fragment SupplierControlPanelProductTranslatorFragment on SupplierControlPanelProductTranslator {
    id
    supplier_id
    updated
    has_empty_columns
    original_sku
    mec_sku
    original_product_name_en
    original_product_name_sv
    original_product_description_en
    original_product_description_sv
    product_name_translations
    product_description_translations
    categories
}